// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/popover/index.css
// module id = 53
// module chunks = 1 2 3 4 5